exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".v-four-box .p-four-box[data-v-5b80f240]{margin-top:0}\n", ""]);
